import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import closeAddDriver from "../../../../../../../assets/images/addDriver/closeAddDiver.svg";
import "./UpdateDriverModal.scss";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import Icon from "app/views/commonComponents/Icon/Icon";
import UpdateDriverInformation from "../UpdateDriverInformation/UpdateDriverInformation";
import Loader from "react-js-loader";
const UpdateDriverModal = ({ onClose, driverId }) => {
  console.log("driverId2", driverId);

  return (
    <Card className={"updateDriverInputCard"}>
      <CardBody>
        <div className="updateDriverContainer">
          <div className="updateDriverTitle">
            <div className="updateDriverStyle">Update Information</div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Icon
                size="regular"
                buttonType="secondary"
                image={closeAddDriver}
                onClick={onClose}
              ></Icon>
            </div>
          </div>
          {<UpdateDriverInformation onClose={onClose} driverId={driverId} />}
        </div>
      </CardBody>
    </Card>
  );
};

export default UpdateDriverModal;
